import Vue from 'vue';
import App from '@/App.vue';
import '@/registerServiceWorker';
import router from '@/router/router';
import store from '@/store/store';
import vuetify from '@/plugins/vuetify';
import i18n from '@/i18n';
import Vuelidate from 'vuelidate';
import Sentry from '@/sentry/sentry';
import axiosInterceptor from '@/utils/axiosInterceptor'

import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.config.productionTip = false;

axiosInterceptor()

// Vuelidate
Vue.use(Vuelidate);

// moment.js for Vue
const moment = require('moment');
Vue.use(require('vue-moment'), {
    moment
});

// moment.js locale setup
moment.locale(store.getters["identity/getLocale"] || 'cs');
store.watch(() => store.getters["identity/getLocale"], () => {
    moment.locale(store.getters["identity/getLocale"] || 'cs');
});

// Sentry
Sentry.init();

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
